import { Button, DatePicker, message } from 'antd'
import { tvaCalculateMonthly } from 'api/pgads'
import { ErrorContext, SpinContext } from 'context'
import { getApiTargetInfo } from 'core'
import { Content, Label, Title } from 'core/screen-util'
import moment from 'moment'
import React, { useContext, useState } from 'react'
import { connect } from 'react-redux'

const { MonthPicker } = DatePicker

const TvaMonthlyCalculation = ({ targetInfo }) => {
  const [monthYear, setMonthYear] = useState(moment())
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)

  const handleProcess = _ => {
    if (!monthYear || !targetInfo) return
    const year = monthYear.year()
    const month = monthYear.month() + 1
    setSpinning(true)
    tvaCalculateMonthly(targetInfo)({ year, month }).fork(
      err => {
        setSpinning(false)
        setError(err)
      },
      _ => {
        setSpinning(false)
        message.success('Monthly calculation completed successfully.')
      }
    )
  }

  return (
    <Content>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '150px 220px auto',
          gap: 20,
          alignItems: 'center',
        }}
      >
        <Title style={{ gridColumn: '1 / -1' }}>Monthly Calculation Save</Title>
        <Label>Month / Year :</Label>
        <MonthPicker
          value={monthYear}
          onChange={setMonthYear}
          format="MMMM YYYY"
          placeholder="Select month"
          allowClear={false}
          style={{ width: '100%' }}
        />
        <Button
          type="primary"
          onClick={handleProcess}
          disabled={!monthYear}
          style={{ justifySelf: 'start' }}
        >
          Process
        </Button>
      </div>
    </Content>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(TvaMonthlyCalculation)
